/**
 * This script is not built the normal way,
 * see nextjs config for the referencing
 */

const makeLocalStorageHandler = (key, defaultData, expireAfter) => {
  const get = () => {
    try {
      const stored = localStorage.getItem(key)
      if (stored) {
        const { data, expiration } = JSON.parse(stored)
        if (expiration && expiration < new Date().getTime()) {
          localStorage.removeItem(key)
          return defaultData
        }
        return data
      }
    } catch {}
    return defaultData
  }

  const set = (data) => {
    try {
      const expiration = expireAfter ? new Date().getTime() + expireAfter : undefined
      localStorage.setItem(key, JSON.stringify({ data, expiration }))
    } catch {}
  }
  const clear = () => {
    try {
      localStorage.removeItem(key)
    } catch {}
  }

  return { get, set, clear }
}

const pageReloadAttemptsLocalStorageHandler = makeLocalStorageHandler(
  'fuse.chunk-load-failures',
  {
    problematicUrl: '',
    attemptsCount: 0,
  },
  1000 * 30,
)

let gotLoadingChunkFailedError = false
globalThis.window?.addEventListener('error', (e) => {
  if (/Loading chunk [\d]+ failed/.test(e.message)) {
    const storage = pageReloadAttemptsLocalStorageHandler.get()
    const problematicUrl = storage.problematicUrl || window.location.href
    gotLoadingChunkFailedError = true
    switch (storage.attemptsCount) {
      case 0: {
        pageReloadAttemptsLocalStorageHandler.set({ attemptsCount: 1, problematicUrl })
        window.location.reload()
        break
      }
      case 1: {
        pageReloadAttemptsLocalStorageHandler.set({ attemptsCount: 2, problematicUrl })
        window.location.reload()
        break
      }
      case 2: {
        pageReloadAttemptsLocalStorageHandler.set({ attemptsCount: 3, problematicUrl })
        window.location.href = '/'
        break
      }
      case 3: {
        console.error(
          `Getting Loading Chunk Failed error even after two page reloads and root redirect, url: ${problematicUrl}`,
        )
        break
      }
    }
  }
})

if (globalThis.window) {
  setTimeout(() => {
    if (gotLoadingChunkFailedError) return
    const { problematicUrl, attemptsCount } = pageReloadAttemptsLocalStorageHandler.get()
    if (attemptsCount === 0) return
    globalThis.window.DD_RUM?.addAction('page-restoration-after-chunks-loading-failure', {
      problematicUrl,
      attemptsCount,
    })
  }, 1000 * 5)
}
